import { Buffer3384y49aj0pxr as Buffer } from './Buffer.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealBufferedSinkClass;
function RealBufferedSink() {
  if (RealBufferedSinkClass === VOID) {
    class $ {
      constructor(sink) {
        this.g40_1 = sink;
        this.h40_1 = false;
        this.i40_1 = new (Buffer())();
      }
      x3v(source, byteCount) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.h40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.i40_1.x3v(source, byteCount);
        this.j40();
        return Unit_instance;
      }
      n3z(byteString) {
        // Inline function 'okio.internal.commonWrite' call
        // Inline function 'kotlin.check' call
        if (!!this.h40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.i40_1.n3z(byteString);
        return this.j40();
      }
      p3z(string) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.h40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.i40_1.p3z(string);
        return this.j40();
      }
      q3z(string, beginIndex, endIndex) {
        // Inline function 'okio.internal.commonWriteUtf8' call
        // Inline function 'kotlin.check' call
        if (!!this.h40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.i40_1.q3z(string, beginIndex, endIndex);
        return this.j40();
      }
      r3z(b) {
        // Inline function 'okio.internal.commonWriteByte' call
        // Inline function 'kotlin.check' call
        if (!!this.h40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        this.i40_1.r3z(b);
        return this.j40();
      }
      j40() {
        // Inline function 'okio.internal.commonEmitCompleteSegments' call
        // Inline function 'kotlin.check' call
        if (!!this.h40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        var byteCount = this.i40_1.y3y();
        if (byteCount > 0n) {
          this.g40_1.x3v(this.i40_1, byteCount);
        }
        return this;
      }
      lc() {
        // Inline function 'okio.internal.commonFlush' call
        // Inline function 'kotlin.check' call
        if (!!this.h40_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.i40_1.z3v_1 > 0n) {
          this.g40_1.x3v(this.i40_1, this.i40_1.z3v_1);
        }
        this.g40_1.lc();
        return Unit_instance;
      }
      l6() {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'okio.internal.commonClose' call
          if (this.h40_1) {
            tmp$ret$0 = Unit_instance;
            break $l$block;
          }
          var thrown = null;
          try {
            if (this.i40_1.z3v_1 > 0n) {
              this.g40_1.x3v(this.i40_1, this.i40_1.z3v_1);
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              thrown = e;
            } else {
              throw $p;
            }
          }
          try {
            this.g40_1.l6();
          } catch ($p) {
            if ($p instanceof Error) {
              var e_0 = $p;
              if (thrown == null)
                thrown = e_0;
            } else {
              throw $p;
            }
          }
          this.h40_1 = true;
          if (!(thrown == null))
            throw thrown;
          tmp$ret$0 = Unit_instance;
        }
        return tmp$ret$0;
      }
      toString() {
        // Inline function 'okio.internal.commonToString' call
        return 'buffer(' + toString(this.g40_1) + ')';
      }
    }
    initMetadataForClass($, 'RealBufferedSink');
    RealBufferedSinkClass = $;
  }
  return RealBufferedSinkClass;
}
//region block: exports
export {
  RealBufferedSink as RealBufferedSinkipqv3pv5gqfq,
};
//endregion

//# sourceMappingURL=RealBufferedSink.mjs.map
